import { IoLogoSass } from "react-icons/io";
import { FaVuejs, FaGit } from "react-icons/fa";
import { TbBrandNextjs, TbBrandTailwind } from "react-icons/tb";
import { SiTypescript, SiJavascript, SiBootstrap, SiGreensock, SiReact, SiGraphql, SiRedux, SiVuetify } from "react-icons/si";

export const languages = () => {
  return (
  <div className="skills">
    <div className="skill">
      <h5>
        <span>
          <TbBrandNextjs color="#000"/>{" "}
        </span>
        Next.js
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiJavascript color="#F7DF1E"/>{" "}
        </span>
        JavaScript
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <IoLogoSass color="#1C7DB4"/>{" "}
        </span>
        SASS
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <TbBrandTailwind color="#1572B6"/>{" "}
        </span>
        Tailwind
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiTypescript color="#1C7DB4"/>{" "}
        </span>
        TypeScript
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiBootstrap color="#5B4282"/>{" "}
        </span>
        Bootstrap
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiGreensock color="#50C878"/>{" "}
        </span>
        GSAP
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <FaVuejs color="#42B883"/>{" "}
        </span>
        Vue
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiReact color="#61DAFB"/>{" "}
        </span>
        ReactJs
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiGraphql color="#BE2DF1"/>{" "}
        </span>
        GraphQL
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiRedux color="purple"/>{" "}
        </span>
        Redux
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <SiVuetify color="#42B883"/>{" "}
        </span>
        Vuetify
      </h5>
    </div>
    <div className="skill">
      <h5>
        <span>
          <FaGit color="#000"/>{" "}
        </span>
        Git
      </h5>
    </div>
  </div>
  )
};
